export const MODAL_TYPES = {
    CUSTOM_REPORT: 'custom_report',
    SHARE: 'share',
}
